import Swiper from 'swiper';
import {Pagination, Autoplay} from 'swiper/modules';
import 'swiper/css';
import 'swiper/css/pagination';

//console.log('Hero Slider - plik view.js załadowany');

(function () {
    function initHeroSwiper() {
        //console.log('Inicjalizacja Swipera uruchomiona');

        // Poczekaj na pełne załadowanie DOM
        const heroSliders = document.querySelectorAll('.hero-slider-container');
        //console.log('Znaleziono sliderów:', heroSliders.length);

        if (heroSliders.length > 0) {
            heroSliders.forEach((slider, index) => {
                //console.log(`Inicjalizacja slidera ${index + 1}`);

                try {
                    // Sprawdź, czy Swiper jest dostępny
                    if (typeof Swiper !== 'function') {
                        console.error('Swiper nie jest prawidłowo zaimportowany!');
                        return;
                    }

                    // Sprawdź strukturę slidera
                    const slidesWrapper = slider.querySelector('.swiper-wrapper');
                    const slides = slidesWrapper ? slidesWrapper.querySelectorAll('.swiper-slide') : [];
                    //console.log(`Slider ${index + 1} ma ${slides.length} slajdów`);

                    if (slides.length === 0) {
                        console.warn(`Slider ${index + 1} nie ma slajdów!`);
                        return;
                    }

                    // Poprawa: Sprawdź poprawną ścieżkę do elementów nawigacji
                    const navContainer = slider.querySelector('.hero-slider-navigation .hero-slider--title');

                    if (!navContainer) {
                        console.warn(`Nie znaleziono kontenera nawigacji (.hero-slider--title) dla slidera ${index + 1}`);
                    } else {
                        //console.log('Znaleziono kontener nawigacji:', navContainer);
                    }

                    const navItems = navContainer ? navContainer.querySelectorAll('.hero-slider--title__text') : [];
                    //console.log(`Znaleziono ${navItems.length} elementów nawigacji`);

                    // Inspekcja elementów nawigacji
                    navItems.forEach((item, idx) => {
                        //console.log(`Element nawigacji ${idx}:`, item.textContent.trim());
                    });

                    // Inicjalizacja Swipera
                    const swiper = new Swiper(slider, {
                        modules: [Pagination, Autoplay],
                        slidesPerView: 1,
                        spaceBetween: 0,
                        pagination: {
                            el: '.swiper-pagination',
                            clickable: true
                        },
                        autoplay: {
                            delay: 3000,
                            disableOnInteraction: false
                        },
                        loop: true,
                        watchSlidesProgress: true
                    });

                    // Dodaj obsługę kliknięć dla niestandardowej nawigacji
                    if (navItems.length > 0) {
                        // Aktywuj pierwszy element
                        navItems[0].classList.add('active');

                        navItems.forEach((navItem, idx) => {
                            //console.log(`Dodaję listener do elementu nawigacji ${idx}`);

                            // Dodaj debugowanie eventów
                            navItem.addEventListener('mouseover', function () {
                                //console.log(`Najechanie na element nawigacji ${idx}`);
                            });

                            navItem.addEventListener('click', function (e) {
                                //console.log(`Kliknięto element nawigacji ${idx}`);
                                e.preventDefault();
                                e.stopPropagation();

                                // Usuń klasę active z wszystkich elementów
                                navItems.forEach(item => item.classList.remove('active'));

                                // Dodaj klasę active do klikniętego elementu
                                navItem.classList.add('active');

                                // Przejdź do odpowiedniego slajdu
                                // POPRAWKA: Nie dodawaj +1, jeśli spowoduje to problemy
                                swiper.slideTo(idx);

                                //console.log(`Przełączono na slajd ${idx}`);
                            });
                        });

                        // Aktualizuj aktywny element nawigacji gdy zmienia się slajd
                        swiper.on('slideChange', function () {
                            const realIndex = swiper.realIndex;
                            //console.log(`Zmiana slajdu, aktywny indeks: ${realIndex}`);

                            navItems.forEach((item, i) => {
                                if (i === realIndex) {
                                    item.classList.add('active');
                                } else {
                                    item.classList.remove('active');
                                }
                            });
                        });
                    } else {
                        console.warn('Nie znaleziono elementów nawigacji!');
                    }

                    //console.log(`Slider ${index + 1} zainicjalizowany pomyślnie`);

                } catch (e) {
                    console.error(`Błąd inicjalizacji Swipera dla slidera ${index + 1}:`, e);
                }
            });

            // Funkcja do aktualizacji wyświetlania obrazów w zależności od szerokości ekranu
            function updateSliderImages() {
                const width = window.innerWidth;

                heroSliders.forEach((slider) => {
                    const slides = slider.querySelectorAll('.swiper-slide');
                    slides.forEach((slide) => {
                        // Pokaż odpowiednie zdjęcie w zależności od szerokości ekranu
                        const desktopImage = slide.querySelector('.desktop-image');
                        const mobileImage = slide.querySelector('.mobile-image');

                        if (!desktopImage && !mobileImage) return;

                        if (width < 960) {
                            if (mobileImage) mobileImage.style.display = 'block';
                            if (desktopImage) desktopImage.style.display = 'none';
                        } else {
                            if (desktopImage) desktopImage.style.display = 'block';
                            if (mobileImage) mobileImage.style.display = 'none';
                        }
                    });
                });
            }

            // Wywołaj funkcję przy ładowaniu i zmianie rozmiaru okna
            updateSliderImages();
            window.addEventListener('resize', updateSliderImages);
        } else {
            console.warn('Nie znaleziono żadnego slidera na stronie');
        }
    }

    // Dodaj manualny testowy listener na wszystkie elementy nawigacji
    function addManualListeners() {
        //console.log('Dodaję manualne listenery na wszystkie elementy nawigacji');

        const allNavItems = document.querySelectorAll('.hero-slider--title__text');
        //console.log(`Znaleziono ${allNavItems.length} elementów nawigacji globalnie`);

        allNavItems.forEach((item, idx) => {
            item.style.cursor = 'pointer'; // Dodaj kursor wskazujący

            item.addEventListener('click', function (e) {
                //console.log(`Kliknięto element nawigacji ${idx} (manualny listener)`);

                // Znajdź kontener slidera
                const sliderContainer = item.closest('.hero-slider-container');
                if (!sliderContainer) {
                    console.error('Nie znaleziono kontenera slidera!');
                    return;
                }

                // Znajdź instancję Swipera
                const swiperInstance = sliderContainer.swiper;
                if (!swiperInstance) {
                    console.error('Nie znaleziono instancji Swipera!');
                    return;
                }

                // Znajdź wszystkie elementy nawigacji w tym samym kontenerze
                const navItemsInContainer = sliderContainer.querySelectorAll('.hero-slider--title__text');

                // Usuń klasę active z wszystkich elementów
                navItemsInContainer.forEach(navItem => navItem.classList.remove('active'));

                // Dodaj klasę active do klikniętego elementu
                item.classList.add('active');

                // Przejdź do odpowiedniego slajdu
                const slideIndex = parseInt(item.getAttribute('data-slide-index') || idx);
                swiperInstance.slideTo(slideIndex);

                //console.log(`Przełączono na slajd ${slideIndex}`);
            });
        });
    }

    // Wywołaj inicjalizację po załadowaniu DOM
    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', function () {
            //console.log('DOM załadowany, inicjalizacja slidera');
            setTimeout(initHeroSwiper, 100); // Małe opóźnienie dla pewności
            setTimeout(addManualListeners, 300); // Dodaj dodatkowe listenery po inicjalizacji Swipera
        });
    } else {
        // DOM już załadowany
        //console.log('DOM już załadowany, inicjalizacja slidera natychmiast');
        setTimeout(initHeroSwiper, 100);
        setTimeout(addManualListeners, 300);
    }

    // Bezpieczne wywołanie ponownej inicjalizacji po 1 sekundzie (na wszelki wypadek)
    setTimeout(initHeroSwiper, 1000);
    setTimeout(addManualListeners, 1200);
})();